var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNought({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1500 3000 30000 22000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "none",
    d: "M 10550,6000 C 15341,6000 19000,9659 19000,14450 19000,19241 15341,22900 10550,22900 5759,22900 2100,19241 2100,14450 2100,9659 5759,6000 10550,6000 Z M 2100,6000 L 2100,6000 Z M 19001,22901 L 19001,22901 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "noughtPath",
    fill: "none",
    strokeWidth: 2117,
    strokeLinejoin: "round",
    d: "M 10550,6000 C 15341,6000 19000,9659 19000,14450 19000,19241 15341,22900 10550,22900 5759,22900 2100,19241 2100,14450 2100,9659 5759,6000 10550,6000 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNought);
export default __webpack_public_path__ + "static/media/nought.4b565854192ab8f5f02ef6eefa72dad0.svg";
export { ForwardRef as ReactComponent };